import {
    doc,
    updateDoc,
} from "firebase/firestore";

import {
    updateProfile,
} from "firebase/auth";

import { auth, db } from "../firebase";

export async function updateUserProfile({
    displayName,
    emailUpdates,
}) {

    const user = auth.currentUser;

    if (!user) {
        throw new Error("Not signed in.");
    }

    // Update Firebase Authentication
    await updateProfile(
        user,
        {
            displayName,
        }
    );

    // Update Firestore
    await updateDoc(

        doc(
            db,
            "users",
            user.uid
        ),

        {
            displayName,
            emailUpdates,
        }

    );

}